<template>
  <section v-if="items.length" id="journey" class="journey-section">
    <v-container>
      <p>The Journey</p>
      <div class="journey-strip" :style="{ '--journey-count': items.length }">
        <article v-for="item in items" :key="item.id">
          <span>{{ item.label }}</span>
          <strong>{{ item.value }}</strong>
          <small v-if="item.status === 'coming-soon'">Story Coming Soon</small>
        </article>
      </div>
    </v-container>
  </section>
</template>

<script>
export default { name: 'JourneyStrip', props: { items: { type: Array, default: () => [] } } };
</script>

<style scoped>
.journey-section { background: #0d0d0d; border-top: 1px solid #242424; padding: 48px 0; }
.journey-section p { color: #e23232; font-family: "Oswald", sans-serif; font-weight: 800; text-transform: uppercase; }
.journey-strip { display: grid; grid-template-columns: repeat(var(--journey-count), minmax(170px, 1fr)); overflow-x: auto; padding-bottom: 10px; }
.journey-strip article { border-left: 1px solid #383838; min-height: 95px; padding: 12px 22px; }
.journey-strip span { color: #f0b13c; display: block; font-size: 0.78rem; font-weight: 800; text-transform: uppercase; }
.journey-strip strong { color: #ddd; display: block; font-size: 0.95rem; line-height: 1.45; margin-top: 8px; }
.journey-strip small { color: #858585; display: block; font-size: 0.68rem; font-weight: 800; letter-spacing: 0.05em; margin-top: 9px; text-transform: uppercase; }
</style>
